import React from 'react';
import PropTypes from 'prop-types';
import PopupNg from '@/ui/PopupNg';
import Tooltip from '@/responsive/components/Tooltip/Tooltip';
import { useReframe } from 'nike-re-framejs';
import { LiveMatchOptionsTooltip, PrematchMatchOptionsTooltip } from './MatchOptionsDialog';
import { match$$ } from 'nike-ui/src/components/turboLive/push/overview/subs';

export function LiveMatchOptions({ eventId, pureLive }) {
    const { derefSub } = useReframe();
    const event = eventId && derefSub(match$$(null, eventId));
    function handleClick(e) {
        e.preventDefault();
        e.stopPropagation();
        PopupNg.dispatcher.open('nikeone/matchoptions/live', { eventId, pureLive: pureLive, sportEvent: event });
    }
    return <OptionsButton onClick={handleClick} />;
}

LiveMatchOptions.propTypes = {
    eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export function PrematchMatchOptions({ boxStore, eventId, betId, matchNote, sportEvent }) {
    function handleClick(e) {
        e.preventDefault();
        e.stopPropagation();
        PopupNg.dispatcher.open('nikeone/matchoptions/prematch', {
            boxStore,
            eventId,
            betId,
            matchNote,
            sportEvent
        });
    }

    return <OptionsButton onClick={handleClick} />;
}

PrematchMatchOptions.propTypes = {
    boxStore: PropTypes.string.isRequired,
    eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    betId: PropTypes.string.isRequired
};

const OptionsButton = ({ onClick }) => (
    <button className="more-options flex-center pull-right" onClick={onClick}>
        <div className="icon-more" />
    </button>
);

const PrematchOptionsToolTip = ({ boxStore, eventId, betId }) => (
    <Tooltip optionsButton={<OptionsButton />}>
        <PrematchMatchOptionsTooltip boxStore={boxStore} eventId={eventId} betId={betId} />
    </Tooltip>
);

PrematchOptionsToolTip.propTypes = {
    boxStore: PropTypes.string.isRequired,
    eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    betId: PropTypes.string.isRequired
};
const LiveOptionsToolTip = ({ eventId, pureLive }) => (
    <Tooltip optionsButton={<OptionsButton />}>
        <LiveMatchOptionsTooltip eventId={eventId} pureLive={pureLive} />
    </Tooltip>
);

LiveOptionsToolTip.propTypes = {
    eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
